import { ChipsideComponent } from "../chipside-component";

export class InfoGroupRow extends ChipsideComponent {
	static observedAttributes = ["columns"];

	constructor() {
		super();

		this.columns = parseInt(this.getAttribute("columns")) || -1;

		this.classList.add("information-row");
	}

	parsedCallback() {
		if (this.columns === -1) {
			const columnCount = this.querySelectorAll("chip-infovalue").length;

			if (columnCount < 4) {
				this.columns = columnCount;
			}
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "columns") {
			this.columns = parseInt(newValue) || 4;
		}
	}
}